<template>
    <!-- 商圈商品購物車 -->
    <div class="my-cart">
        <navigation-bar Close :title="'確認訂單'"/>
        <div v-if="cartData.itemList.length===0" class="no-data">
            <img src="@/assets/images/empty.svg">
            <p>OH！目前空空的</p>
        </div>
        <template v-else>
            <div class="main">

                <div class="cart-list">
                    <!--todo 已登入直接帶入會員資料-->
                    <div class="member-list" v-if="isLogin">
                        <el-image :src="logoUrl" fit="cover" class="pic" />
                        <div class="content">
                            Hi, {{userModel.nickName}}
                        </div>
                    </div>

                </div>

                <div class="top-cart-list">
                    <h4>我的訂單</h4>

                    <SlipDel v-for="(item,index) in cartData.itemList " :key="index" class="block">

                        <div class="input-group">

                            <div class="image_empty"  v-if="item.itemImage===''"/>
                            <el-image v-else :src="item.itemImage" fit="cover" lazy  @click.native="goProduct(item)"/>

                            <div class="right">
                                <div class="name" @click="goProduct(item)">{{item.name}}</div>
                                <div class="date" v-show="isItemAdmission(item)">場次 {{item.label}}</div>
                                <div class="d-flex">
                                    <div class="red fee" @click="goProduct(item)">${{isNaN(item.price)? 0: item.price}}</div>
                                    <NumberController :params="{ default: item.buyAmount, min: 0,}" @triggerEvent="numberControllerEvent(arguments, index)" :size="'mini'"/>
                                </div>
                            </div>
                        </div>
                        <div slot="del" @click="[removeProduct(index)]"><img src="@/assets/images/delete_white_line.svg"> </div>
                    </SlipDel>

                </div>
                <div class="shadow-line m-0 mb-4"/>

                <div class="cart-list">
                    <h4>
                        小計
                        <span>${{totalPrice}}</span>
                    </h4>
                </div>
                <div class="cart-list">
                    <h4 id="PayType" v-if="!isTableOrderAddItem">
                        付款方式
                        <el-button type="text" @click="showBank = true" v-if="paymentType !== ''"><i class="el-icon-edit" />
                            更改付款方式
                        </el-button>
                    </h4>

                    <div class="li" :class="required(paymentType)" @click="showPaymentSelect">
                        <span class="red" v-if="paymentType.type === undefined"><i class="el-icon-warning" /> 請選擇付款方式</span>
                        <span v-if="paymentType.type !== undefined">
                            <template v-if="paymentType.type !== 'newebpayMPG'">
                                <img :src="getIcon()" class="card-pic">
                                {{ paymentType.name }}
                            </template>
                            <template v-else>
                                <template v-if="paymentType.selectFlag === 0">
                                    <img :src="require('@/assets/images/pay/other_pay_credit_card2.svg')" class="card-pic"/>
                                    信用卡
                                </template>
                                <template v-else-if="paymentType.selectFlag === 100">
                                    <img :src="require('@/assets/images/pay/other_pay_googlepay.svg')" class="card-pic"/>
                                    Google Pay
                                </template>
                                <template v-else-if="paymentType.selectFlag === 101">
                                    <img :src="require('@/assets/images/pay/other_pay_samsungpay.svg')" class="card-pic"/>
                                    Samsung Pay
                                </template>
                                <template v-else>
                                    <img :src="require('@/assets/images/pay/other_pay_credit_card2.svg')" class="card-pic"/>
                                    信用卡分期 - {{ paymentType.selectFlag }}期
                                </template>
                            </template>
                        </span>
                        <span class="float-right red">${{nowPay}}</span>
                    </div>

                </div>

                <!--TODO 更改付款方式-->
                <bank-card v-if="showBank" :paymentType="paymentType" @callback="onBankCardCallback"
                           :objectType="4" :objectId="shopAreaId" :funcTypeId="funcTypeId"
                           @changePaymentType="changePaymentType"/>

                <!--todo 發票載具+統編--->
                <div class="cart-list no-after" v-show="isCanMobileBarcode || isCanTaxIdNumber">
                    <h4>發票資料</h4>
                    <!--todo 手機條碼-->
                    <MobileBarcode v-show="isCanMobileBarcode" @update="mobileBarcodeUpdate" :value="mobileBarcode"  />
                    <!--todo 統一編號-->
                    <TaxIdNumber v-show="isCanTaxIdNumber" @update="taxIdNumberUpdate" :value="taxIdNumber"/>
                </div>

                <!--todo 結帳後彈框-->
                <el-dialog
                        :visible.sync="finalCheckModel"
                        append-to-body
                        :show-close="false"
                        :close-on-click-modal="false"
                        class="dialog"
                        custom-class="commDialog">
                    <div class="container text-center">
                        <img src="@/assets/images/dialog-exchange.svg" class="mb-0 icon">
                        <div slot="title" class="outer-content p-0">
                            付款後將無法進行任何修改
                        </div>
                        <p class="main-content mt-3 mb-3 min-w-140 text-left">
                            付款金額 : ${{totalPrice}}<br>
                            付款方式 : {{getPaymentName()}}
                        </p>

                        <div slot="footer" class="dialog-footer">
                            <el-button type="info" @click="finalCheckModel=false">取消</el-button>
                            <el-button type="warning" @click="doCheck">付款</el-button>
                        </div>
                    </div>
                </el-dialog>
            </div>

            <!--todo 刪除餐點彈框-->
            <el-dialog :visible.sync="isDelDialogShow" append-to-body top="20%" width="80%" custom-class="commDialog"
                       @close="closeDelDialog('no')">
                <div class="container">
                    <img src="../../assets/images/dialog-order.svg" class="icon">
                    <h4 class="text-center">確定要刪除此商品？</h4>
                    <div class="dialog-footer">
                        <el-button @click="[closeDelDialog(true)]" type="info">確定刪除</el-button>
                    </div>
                </div>
            </el-dialog>

            <div class="CartButton">
                <div class="button" @click="onClickCheckOut">
                    <div class="number">
                        {{itemAmount}}
                    </div>
                    <div class="text">
                        結帳
                    </div>
                    <div class="fee">
                        ${{nowPay}}
                    </div>
                </div>
            </div>
            <comm-dialog ref="dialog" :value="commDialogShow" :outerContent="dialogTitle" :isCancel="false"
                         @result="closeCommDialog"
                         @close="(value) => { commDialogShow = value }"/>
        </template>
        <loading :active.sync=isLoading :can-cancel="false" :is-full-page="true"/>
    </div>
</template>

<script>
import BankCard from '../order/components/BankCard.vue';
import NumberController from '../../components/NumberController'
import SlipDel from 'vue-slip-delete';
import Cart from '@/util/cart';
import * as constDefine from "@/store/constDefine";
import CommDialog from '@/components/CommDialog.vue';
import * as mutationTypes from "@/store/mutationTypes";
import {getCryptoUserInfo} from "@/util/cryptoLocalStorage";
import TaxIdNumber from "../../components/TaxIdNumber";
import MobileBarcode from "../../components/MobileBarcode";
import {checkMobileBarcode} from "@/util/validators";

    export default {
        name: 'Cart',
        components: {
            NumberController,
            BankCard,
            SlipDel,
            CommDialog,
            TaxIdNumber,
            MobileBarcode,
        },
        data() {
            return {
                logoUrl: "",
                isTableOrderAddItem: false,
                isLoading: false,
                showBank: false,        //更改付款方式
                isDelDialogShow: false,   //刪除餐點彈框
                isDeleteItem: '',     //是否刪除商品 (string, 'yes' or 'no')
                waitingForDeleteID: 0,
                itemAmount: 0,      //商品數量
                totalPrice: 0,      //商品總金額
                nowPay: 0,          //應付總金額
                paymentType: '',
                customerName: '',       //姓名(未登入用)
                customerPhone: '',      //電話(未登入用)
                mobileBarcode: '',      //載具碼
                taxIdNumber: '',        //統一編號
                isCanMobileBarcode: false,      //是否顯示載具填寫
                isCanTaxIdNumber: false,        //是否顯示統一編號填寫
                cartData: {
                    updateTime: "1990-01-01 00:00:00",      //更新時間
                    itemList: [],        //購物車商品陣列，裝 item結構
                    // item: {
                    //     id: 0,      //在資料庫中的ID
                    //     itemId: 0,  //商品id
                    //     title:"" ,  //名稱
                    //     img:"",     //圖片
                    //     buyAmount: 0,  //數量
                    //     fee: 0,     //金額(參考用)
                    //     specIds: [],        //商品規格，金額可能會變動所以不記錄，內裝規格設定的ID
                    //     updateTime: "1990-01-01 00:00:00",      //更新時間
                    // },
                },
                //可刪-購物車假資料
                productList:[],
                numberControllerParams: {
                    default: 1,
                    min: 1,
                },
                finalCheckModel: false,
                cartUpdateKey: 0,         //更新購物車列表用 key
                dataToken: this.$route.query.dataToken !== undefined ? this.$route.query.dataToken : "",        //url 傳來的加密參數
                dataObject: {},     //url加密參數解析後的值
                userModel: {            //user資料
                    nickName: "",
                    userCode: "",
                    userImage: "",
                    userPhone: "",
                },
                isLogin: this.$auth.isAdminLogin(),
                shopAreaId: Cart.checkCartItemsShopAreaId(),
                orderType: 2,       //訂單分類 (1：表單購物車結帳、2：商圈購物車結帳、3：商品QR碼結帳)
                objectType: 4,
                funcTypeId: 5,      //1預訂, 4表單購物車結帳, 5:商圈購物車結帳, 6:商品QRcode結帳



                payResult: {},      //金流結果
                commDialogShow: false,      //dialog (付款成功 用)
                dialogTitle: '',            //dialog文字
                functionAfterDialog: [],    //dialog關閉後要做的事
            }
        },
        computed: {
            //必填共用判斷
            required() {
                return (type) => {
                    //不能為空值
                    return type === "" || type === undefined ? 'required' : ''
                }
            },
        },
        mounted () {
            //載入初始資料

            if (this.isLogin) {
                this.getUserInfo();
                this.setupShoppingAreaInfo();
            }
            // if (this.dataToken !== "") {
                this.initForDataToken(this.dataToken);
            // }


            //暫存 officialName
            // if(!this.$public.isCordova() && sessionStorage.getItem('openShoppingAreaOfficialName') !== null) {
            //     let officialName = sessionStorage.getItem('openShoppingAreaOfficialName');
            //     this.$router.replace({name: this.$route.name, params: {'officialName': officialName}});
            //
            // } else if(!this.$public.isCordova()) {
            //     sessionStorage.setItem('openShoppingAreaOfficialName', this.$route.params.officialName);
            // }
        },
        methods: {

            /** 取資料 */
            setupShoppingAreaInfo: function() {

                if (this.shopAreaId > 0) {
                    let self = this;
                    //取得商圈資料
                    self.isLoading = true;
                    self.getShoppingAreaInfo()
                        .then(() => {
                                self.isLoading = false;
                            }
                        )
                        .catch((error) => {
                            self.isLoading = false;
                            self.$store.commit(mutationTypes.SHOW_TOAST, error);
                        });
                } else {
                    this.$public.showNotify("商圈錯誤，請清除購物車商品後重試", false);
                }
            },

            /** 取資料 */
            setupData: function() {
                let itemList = Cart.getCart();
                if (this.$public.notNull(itemList)) {
                    this.cartData.itemList = itemList;
                    this.itemAmount = Cart.getItemBuyAmount(itemList);
                    this.updateTotalPrice();
                }
            },

            /** 顯示支付方式 */
            showPaymentSelect: function() {
                this.isLogin = this.$auth.isAdminLogin();
                //有登入就直接到結帳，沒有就先跳到登入再回來
                if (this.isLogin) {
                    this.showBank = true;
                } else {
                    this.$public.setPathAfterLogin(`Cart`, "");
                    this.$router.push({name: 'Login'});
                }
            },

            /** 取得支付方式的名稱 */
            getPaymentName(){
                let self = this;
                let paymentName = "";

                if (self.$public.notNull(self.paymentType)) {
                    paymentName = self.paymentType.name;
                }

                return paymentName;
            },

            /** 取得user資料 */
            getUserInfo: function() {
                this.isLogin = this.$auth.isAdminLogin();
                if (this.isLogin) {
                    // let userInfo = localStorage.getItem('userInfo');
                    //console.log(`UserInfo: getItem userInfo : ${userInfo}`);
                    const userData = getCryptoUserInfo();

                    if (this.$public.notNull(userData)) {
                        this.userModel.userImage = userData.picture;
                        this.userModel.nickName = userData.nickName;
                        this.userModel.userCode = userData.userCode;
                        this.userModel.userPhone = userData.phone;
                    }
                } else {
                    this.userModel.nickName = "";
                    this.userModel.userCode = "";
                    this.userModel.userImage = "";
                    this.userModel.userPhone = "";
                }
            },

            /** 計算總價 */
            updateTotalPrice: function() {
                let result = 0;
                if (this.$public.notNull(this.cartData.itemList)) {
                    this.cartData.itemList.forEach((element) => {
                        result += (element.buyAmount * element.price);
                    });
                }
                this.totalPrice = result;
                this.nowPay = this.totalPrice;
            },

            /** 更改付款方式 */
            changePaymentType(val) {
                if (val !== '') {
                    this.paymentType = Object.assign({}, this.paymentType, val);
                }
                // console.log(`changePaymentType : ${JSON.stringify(val)}`);        //newebpayMPG
                this.showBank = false;
            },

            /** 付款 callback */
            onBankCardCallback: function(needLogin) {
                if (needLogin) {
                    this.$router.push({name: 'Login'});
                }
            },

            /** 點擊結帳 */
            onClickCheckOut: function() {
                let self = this;
                if (self.paymentType.name === "" || self.paymentType.name === undefined) {
                    self.$el.style.setProperty('--borderColor333', `${"#EA4E5E"}`);
                    document.getElementById('PayType').scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
                    self.$public.showNotify("請選擇付款方式", false);
                    return false;
                }

                let isLogin = this.$auth.isAdminLogin();
                if (isLogin) {
                    this.doPreCheck();
                } else {
                    this.$router.push({name: 'Login'});
                }
            },

            /** 顯示結帳彈窗 */
            showCheckDialog(){
                this.finalCheckModel = true;
            },

            /** 顯示刪除商品彈窗 */
            showDelDialog: function() {
                let self = this;
                self.isDelDialogShow = true;
            },

            /** 刪除商品彈窗 關閉事件 */
            closeDelDialog: function(isDelete) {
                this.isDelDialogShow = false;
                if (typeof isDelete === "boolean") {
                    if (isDelete) {
                        this.isDeleteItem = 'yes';
                    } else {
                        this.isDeleteItem = 'no';
                    }
                }
            },

            /** 顯示 dialog
             * @callback:字串形態, 關閉dialog後要呼叫的函式名稱
             * */
            showCommDialog: function (title, callback) {
                this.dialogTitle = title;
                if (callback !== '') {
                    this.functionAfterDialog = [callback];
                } else {
                    this.functionAfterDialog = [''];
                }

                this.commDialogShow = true;
            },

            /** 關閉 dialog */
            closeCommDialog: function () {
                this.commDialogShow = false;
                if (this.functionAfterDialog[0] !== '') {
                    this[this.functionAfterDialog[0]]();
                    //清空 callback
                    this.functionAfterDialog = [''];
                }

            },

            /** 回到上三頁 */
            goBack: function() {
                this.$router.go(-3);
            },

            /** 付款前檢查 */
            doPreCheck: function() {
                let self = this;

                //檢查載具與統編
                let errorCode = self.checkBarcodeAndTaxId();
                if (errorCode === 0) {

                    if (this.shopAreaId > 0) {
                        self.showCheckDialog();

                    } else {
                        this.$public.showNotify("商圈錯誤，請清除購物車商品後重試", false);
                    }
                } else if (errorCode === 1) {
                    this.$public.showNotify("請檢查手機條碼或統一編號是否填寫正確", false);
                } else if (errorCode === 2) {
                    this.$public.showNotify("手機條碼或統一編號只能擇一填寫", false);
                }

            },

            /** 付款 */
            doCheck: function() {
                let self = this;

                self.isLoading = true;
                self.preCheckCart()
                    .then(
                        self.checkoutCart
                    )
                    .then( (data) => {
                            //如果函式後有括號，外面要加上空函式宣告，裡面也要有 return，才會是跟上一步驟同步的(要等上面執行完才接着執行)
                            //若是沒有 return的話會變成非同步式，它不等上個步驟執行完就會開始執行
                            // return self.checkCart(constDefine.STORE_BOOKING);
                            self.finalCheckModel = false ;
                            self.isLoading = false;

                            if (self.$public.notNull(data)) {
                                self.showCommDialog("付款成功", "goBack");
                            } else {
                                self.showCommDialog("付款失敗", "");
                            }

                        }
                    )
                    .catch( (error) => {
                        self.isLoading = false;
                        self.finalCheckModel = false ;

                        self.$public.showNotify(error, false);
                    });
            },

            /** 取得 api要用的物品資訊 */
            getCartDataForApi: function() {

                let couponListId = 0;
                let shopAreaCartId = 0;
                let name = '';
                let couponTypeName = '';
                let couponAmount = 0;
                let convertTimeText = '';


                //組成新的商品陣列
                let newList = [];
                let newTicketList = [];
                let self = this;
                this.cartData.itemList.forEach(function (item, index) {
                    if (self.$public.notNull(item.couponListId) && item.couponListId > 0) {

                        couponListId = item.couponListId;
                        // shopAreaCartId = item.shopAreaCartId;
                        shopAreaCartId = item.id;

                        name = '';
                        couponTypeName = '';
                        couponAmount = 0;
                        convertTimeText = '';

                        //取出 stageId
                        let stageId = 0;
                        if (self.$public.notNull(item.stageIdForTime) && item.stageIdForTime > 0) {
                            stageId = item.stageIdForTime;
                        } else if (self.$public.notNull(item.stageIdForDate) && item.stageIdForDate > 0) {
                            stageId = item.stageIdForDate;
                        }
                        //塞入stageId
                        if (self.$public.notNull(item.coupon?.stageId)) {
                            item.coupon.stageId = stageId;
                        }

                        //
                        if (self.$public.notNull(item.coupon)) {
                            name = item.coupon.name;
                            couponTypeName = item.coupon.couponTypeName;
                            convertTimeText = item.coupon.convertTimeText;
                        }
                        couponAmount = item.couponAmount;

                        //票券資料
                        let ticketCartItem = {};
                        if (item.intervalType === 1 || item.intervalType === 2) {
                            ticketCartItem = {
                                stageStartAt: item.stageStartAt,
                                stageEndAt: item.stageEndAt,
                                intervalType: item.intervalType,
                                stageStartTime: item.stageStartTime,
                                stageEndTime: item.stageEndTime,
                                buyNumber: item.buyAmount,
                                stageId: stageId,
                                name: name,
                                couponTypeName: couponTypeName,
                                couponAmount: couponAmount,
                                convertTimeText: convertTimeText,
                                couponListId: couponListId,         //入場憑證用, 票券id, 每場不一樣
                                shopAreaCartId: shopAreaCartId,     //入場憑證用, 入場憑證商品id, 所有入場憑證都是同一個商品id
                            };
                        } else {
                            ticketCartItem = {
                                stageStartAt: item.stageStartAt,
                                stageEndAt: item.stageEndAt,
                                intervalType: item.intervalType,
                                buyNumber: item.buyAmount,
                                stageId: stageId,
                                name: name,
                                couponTypeName: couponTypeName,
                                couponAmount: couponAmount,
                                convertTimeText: convertTimeText,
                                couponListId: couponListId,         //入場憑證用, 票券id, 每場不一樣
                                shopAreaCartId: shopAreaCartId,     //入場憑證用, 入場憑證商品id, 所有入場憑證都是同一個商品id
                            };
                        }
                        newTicketList.tmz_load_push(ticketCartItem);

                        newList.tmz_load_push({
                            id: item.id,
                            selectedNumber: item.buyAmount,
                            ...item
                        });

                    } else {
                        newList.tmz_load_push({
                            id: item.id,
                            selectedNumber: item.buyAmount,
                            ...item
                        });
                    }

                });

                return {
                    selectedProductList: newList,
                    shoppingCartList: newTicketList,    //入場憑證用, 要購買的票券時段的資訊
                };
            },

            /** 預先檢查物品庫存數量，在結帳前要先做 */
            preCheckCart: function() {
                let self = this;

                return new Promise((resolve, reject) => {

                    let userPhoneNumber = "";
                    if (self.isLogin) {
                        userPhoneNumber = self.userModel.userPhone;
                    } else {
                        userPhoneNumber = self.customerPhone;
                    }


                    let cartDataForApi = this.getCartDataForApi();

                    //組成新的商品陣列
                    let selectedProductList = cartDataForApi["selectedProductList"];
                    let shoppingCartList = cartDataForApi["shoppingCartList"];

                    self.$http.fetchWithEncrypt`CheckShoppingCartProduct${{
                        shopAreaTypeId: constDefine.MerchantType.ShoppingArea,
                        shopAreaId: self.shopAreaId,
                        selectedProductList: selectedProductList,
                        phone: userPhoneNumber,          //user的電話號碼，未註冊的 user會得到一個新 token

                        shoppingCartList: shoppingCartList,    //入場憑證用, 要購買的票券時段的資訊
                        //shoppingCartList格式：
                        // shoppingCartList: [
                        //     {
                        //         "stageStartAt": "2024-03-26",
                        //         "stageEndAt": "2024-03-26",
                        //         "intervalType": 2,       //如果是 3 or 4，就不用帶時段
                        //         "stageStartTime": "09:00",
                        //         "stageEndTime": "11:00",
                        //         "buyNumber": 166
                        //     },...
                        // ]
                    }}
                    ${json => {
                        if (json.status) {

                            if (self.$public.notNull(json.data?.result)) {
                                //票券錯誤解析
                                self.analyzeApiError(json.data.result);

                            } else {
                                if (!self.isLogin && self.$public.notNull(json.data.token)) {
                                    self.$auth.setAdminToken(json.data.token);
                                }
                            }
                            //是票券的話會回傳是否可購買的資訊

                            resolve(json.data);
                        } else {
                            reject(json.message);
                        }
                    }}`;
                })
            },

            /** 檢查載具與統編, 0:ok, 1:檢查有錯, 2:重複填寫 */
            checkBarcodeAndTaxId: function() {
                let isMobileBarcodeEmpty = false;
                let isMobileBarcodeOK = false;
                let isTaxIdNumberEmpty = false;
                let isTaxIdNumberOK = false;

                isMobileBarcodeEmpty = !(this.$public.notNull(this.mobileBarcode) && this.mobileBarcode !== '');
                isTaxIdNumberEmpty = !(this.$public.notNull(this.taxIdNumber) && this.taxIdNumber !== '');

                //檢查手機條碼(載具)
                if (!isMobileBarcodeEmpty) {
                    isMobileBarcodeOK = this.$public.reg( 'mobileBarcode', this.mobileBarcode, "");
                }
                //檢查統一編號
                if (!isTaxIdNumberEmpty) {
                    isTaxIdNumberOK = this.$public.reg( 'taxIdNumber', this.taxIdNumber, "");
                }

                if (isMobileBarcodeEmpty && isTaxIdNumberEmpty) {
                    return 0;
                }  else if (!isMobileBarcodeEmpty && !isTaxIdNumberEmpty) {
                    //兩個都寫也不行
                    return 2;
                } else if (!isMobileBarcodeEmpty && isMobileBarcodeOK) {
                    return 0;
                } else if (!isTaxIdNumberEmpty && isTaxIdNumberOK) {
                    return 0;
                }
                return 1;
            },

            /** 檢查載具與統編 */
            getBarcodeOrTaxId: function() {
                if ( this.checkBarcodeAndTaxId() === 0) {
                    if (this.$public.notNull(this.mobileBarcode) && this.mobileBarcode !== '') {
                        return this.mobileBarcode;

                    } else if (this.$public.notNull(this.taxIdNumber) && this.taxIdNumber !== '') {
                        return this.taxIdNumber;
                    }
                }
                return '';
            },

            /** 結帳 */
            checkoutCart: function() {
                let self = this;
                return new Promise((resolve, reject) => {

                    let isCordova = self.$public.isCordova();

                    // let newList = [];
                    // self.cartData.itemList.forEach(function (item, index) {
                    //     item.selectedNumber = item.buyAmount;
                    // });
                    // newList = self.cartData.itemList;

                    let cartDataForApi = this.getCartDataForApi();

                    //組成新的商品陣列
                    let selectedProductList = cartDataForApi["selectedProductList"];

                    //統編或載具
                    let carrierNumber = this.getBarcodeOrTaxId();

                    //金流專案需要的相關資料
                    if ( self.$public.notNull(self.paymentType) && self.paymentType.type === "newebpayMPG") {
                        self.$payment.paymentRequest = {
                            storeToken: self.$crypto.encryptText(String(-1)),
                            objectTypeToken: self.$crypto.encryptText(String(constDefine.MerchantType.ShoppingArea)),
                            objectIdToken: self.$crypto.encryptText(String(self.shopAreaId)),
                            paymentType: self.paymentType.type,
                            paymentInstFlag: String(self.paymentType.selectFlag),               //選定的付款方式代碼， 0, 3, 6, 9分期的期數
                            method: "shoppingAreaCart",
                            apiToPay: "PayByCreditCard",
                            apiToFunc: "ShoppingAreaCartTradeClose",
                            homeUrl: isCordova? "": window.location.href,
                            funcId: self.funcTypeId,
                        };
                    }

                    self.$http.fetchWithAuthEncrypt`CreateShoppingAreaCartOrder${{
                        userId: self.userId,
                        totalPrice: self.totalPrice,
                        orderRelation: {
                            OrderType: self.orderType,//訂單分類(1：表單購物車結帳、2：商圈購物車結帳、3：商品QR碼結帳)
                            OrderFrom: "app", //self.formData.writeType,//訂單來源(web、app)
                            ObjectType: constDefine.MerchantType.ShoppingArea,//商圈就用 ShoppingArea、商圈活動就用 ShoppingAreaActivity
                            ObjectId: self.shopAreaId,//對應的id
                            PaymentId: self.paymentType.id,//根據支付方式
                            PaymentType: self.paymentType.type,//根據支付方式
                        },
                        payRequest: self.$payment.paymentRequest,
                        selectedProductList: selectedProductList,

                        carrierNumber: carrierNumber,           //載具

                    }}
                    ${async json => {
                        if (json.status) {
                            let isCordova = self.$public.isCordova();

                            if (self.$public.notNull(json.data.orderTmpId)) {
                                //信用卡使用的暫存訂單編號
                                self.$payment.paymentRequest = {
                                    ...self.$payment.paymentRequest, ...{
                                        orderTmpId: json.data.orderTmpId,
                                        isApp: isCordova,
                                    }
                                };

                            // console.log(`payResult: ${JSON.stringify(self.$payment.paymentRequest)}`);

                                //確認金流閘道
                                self.payResult = await self.$payment.getPayment(self.$payment.paymentRequest);
                                //付款完成彈出視窗內容
                                if (self.payResult.status) {
                                    // console.log(`payResult: ${JSON.stringify(self.payResult)}`);
                                    // if (isCordova) {
                                    //     console.log(`cordova:`);
                                    // } else {
                                    //     console.log(`not cordova:`);
                                    // }

                                    //清空購物車
                                    Cart.clearCart();
                                    resolve(self.payResult.message);

                                } else {
                                    //console.log(`payResult false: ${JSON.stringify(self.payResult)}`);
                                    reject(self.payResult.message);
                                }
                            } else {
                                reject('訂單建立錯誤, 無法取得訂單ID');
                            }

                        } else {
                            reject(json.message);
                        }
                    }}`;

                })
            },

            /** 取得商圈資訊 */
            getShoppingAreaInfo: function () {

                let self = this;
                return new Promise(function(resolve, reject) {
                    //夜市商圈列表
                    self.$http.fetch`GetShoppingAreaInfo${{
                        shopAreaId: self.shopAreaId,
                    }} ${json => {
                        if (self.$public.notNull(json.data)) {
                            self.isCanMobileBarcode = json.data.isCanCarrierNumber;
                            self.isCanTaxIdNumber = json.data.isCanTaxIdNumber;

                            //完畢
                            resolve();

                        } else {
                            reject("無法讀取商圈資訊");
                        }
                    }}`;
                });
            },

            /** 數量變動 (注意，args 會因爲接收的函式的參數定義不同，改變自己的結構) */
            numberControllerEvent(args, index) {
                let self = this;
                if (this.$public.notNull(this.cartData.itemList)) {
                    let item = this.cartData.itemList[index];

                    if (args[0].number <= 0) {
                        //跳出刪除確認彈窗
                        this.isDeleteItem = '';
                        this.showDelDialog();

                        this.waitingForDelete()
                            .then( data => {
                                if (data) {
                                    this.changeAmount(item, args[0].number);
                                    Cart.updateCartItem(item);
                                    this.setupData();
                                    //更新購物車顯示
                                    this.onCartUpdate();
                                }
                            })
                            .catch((error) => {
                                this.$public.showNotify(error, false);
                            });

                    } else {
                        this.changeAmount(item, args[0].number);
                        Cart.updateCartItem(item);
                        this.setupData();
                        //更新購物車顯示
                        this.onCartUpdate();
                    }
                }
                this.updateTotalPrice();
            },

            /** 等待刪除 */
            waitingForDelete: function() {
                let self = this;
                return new Promise( function(resolve, reject) {
                    self.waitingForDeleteID = window.setInterval(function () {
                        if (self.isDeleteItem !== '') {
                            resolve(self.isDeleteItem === 'yes');
                            window.clearInterval(self.waitingForDeleteID);
                        }
                    }, 300);

                });
            },

            /** 數量變動 */
            changeAmount: function(item, buyAmount) {
                if (buyAmount !== null && !isNaN(buyAmount)) {
                    item.buyAmount = buyAmount;
                    if (item.buyAmount >= 99) {
                        item.buyAmount = 99;
                    } else if (item.buyAmount <= 0) {
                        item.buyAmount = 0;
                    }
                }
            },

            /** 手機條碼更新 */
            mobileBarcodeUpdate: function(value) {
                if (this.$public.notNull(value)) {
                    this.mobileBarcode = value;
                }
            },

            /** 統一編號更新 */
            taxIdNumberUpdate: function(value) {
                if (this.$public.notNull(value)) {
                    this.taxIdNumber = value;
                }
            },

            /** 刪除商品 */
            removeProduct(index){
                if (this.$public.notNull(this.cartData.itemList)) {
                    let item = this.cartData.itemList[index];

                    this.changeAmount(item, 0);
                    Cart.updateCartItem(item);
                    this.setupData();
                }
                this.updateTotalPrice();
                //更新購物車顯示
                this.onCartUpdate();
            },

            /** 更新購物車顯示 */
            onCartUpdate() {
                this.$store.commit('updateShopAreaCart', -1);
            },

            /** 點擊 商品 */
            goProduct(item){
                let itemId = item.id;
                let shopAreaId = item.shopAreaId;
                let dataToken = this.cryptDataToken({"itemId": itemId, "shopAreaId": shopAreaId});
                this.$router.push({name: 'Product', query: {"dataToken": dataToken}});
            },

            /** 商品是否是入場憑證 */
            isItemAdmission(item){
                return (this.$public.notNull(item.label) && item.label!=='');
            },

            /** 分析票券結帳錯誤原因 */
            analyzeApiError: function(item) {
                let self = this;
                if (self.$public.notNull(item?.result) && item?.result.length > 0) {
                    let BreakException = {};
                    try {
                        item.result.forEach(function (item1) {
                            if (item1.status === 0) {
                                self.showCommDialog(`${item1.stageStartAt} ${item1.stageStartTime}場次票券已無法購買`, "");
                                throw BreakException;
                            }
                        });
                    } catch (e) {
                        if (e !== BreakException) throw e;
                    }
                }
            },

            /** 有使用加密型參數 dataToken時的初始函式 */
            initForDataToken: function(item) {
                try {
                    this.setupData();

                } catch (e) {
                    // this.$router.push({name:'Error'});
                    return false;
                }
            },

            /** 組裝 dataToken */
            cryptDataToken: function(item) {
                return this.$crypto.objectToURIComponent(item) ;
            },

            /** 解析 dataToken */
            decryptDataToken: function(item) {
                return this.$crypto.uriComponentToObject(item);
            },
        },
    }
</script>
<style lang="less" scoped src="../../less/order.less"/>
<style lang="less" scoped>
    .block{
        .input-group {
            padding-top: 15px;
            .el-image , .image_empty{
                flex: 0 0 80px;
                height: 80px;
                border-radius: 10px;
                margin-right: 8px;
                /deep/img{
                    width: 100% !important;
                }
            }
            .right{
                flex: 1;
                .name{
                    overflow:hidden;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    word-break: break-all;

                }
                .d-flex{
                    .fee{
                        flex: 1;
                        height: 40px;
                        line-height: 40px;
                        text-align: left;
                    }
                }

            }
        }
    }
    .member-list{
        padding-bottom: 10px;
        text-align: center;
        .pic{
            width: 40px;
            height: 40px;
            border-radius: 12px;
            border: 1px solid var(--color-gray);
        }
        .content{
            font-size: 18px;
            word-break: break-all;
            overflow:hidden;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
        }
    }
    .addCart{
        //手機版不用購物車icon
        @media(max-width: 1023px){
            display: none;
        }
    }
</style>